import React, { useCallback } from 'react';
import { Tabs, Tab, TabList, TabPanel } from 'react-tabs';

import {
  useToggle,
  // useDocumenHiddenOverflow,
  useTabIndex,
  useAuthActions,
} from '../../hooks';
import { HEADER_MENU_ITEMS } from '../../constants/headerMenuItems';
import { toBucketAssets } from '../../utils/assets';
import { classNames } from '../../utils/css';

import MobileMenuProvider from './mobileMenuContext';
import MobileMenuTabPanelContent from './mobileMenuTabPanelContent';

const MobileMenu = ({ isLogged }) => {
  const [open, toggleOpen] = useToggle(false);

  // useDocumenHiddenOverflow(open);

  const { tabIndex, handleSelectTabIndex, resetTabIndex } = useTabIndex(0);

  const handleClose = useCallback(() => {
    toggleOpen(false);
    resetTabIndex();
  }, [resetTabIndex, toggleOpen]);

  const { handleRedirectToLogin, handleRedirectToRegister, handleLogout } =
    useAuthActions({
      onRedirectLogin: handleClose,
      onRedirectRegister: handleClose,
      onLogout: handleClose,
    });

  return (
    <div className="mobile_menu_root">
      <button
        type="button"
        className="mobile_menu__btn"
        onClick={() => toggleOpen()}
      >
        <div className="mobile_menu__btn__lines" />
      </button>

      <MobileMenuProvider value={{ open, toggleOpen }}>
        {open && (
          <nav className="mobile_menu__nav">
            <div className="mobile_menu__nav__header">
              <img
                src={toBucketAssets('logo.svg')}
                alt="KM Logo"
                className="mobile_menu__main_logo"
              />

              <button
                className="mobile_menu__close_btn"
                onClick={handleClose}
              >
                &#10005;
              </button>
            </div>

            <div className="mobile_menu__nav__content">
              <Tabs
                selectedIndex={tabIndex}
                onSelect={handleSelectTabIndex}
                className="mobile_menu__tabs"
              >
                <TabList className="mobile_menu__tabs__list">
                  {HEADER_MENU_ITEMS.map(({ label }) => (
                    <Tab
                      key={`mobile-menu-tabs-${label}`}
                      className="mobile_menu__tab"
                      selectedClassName="mobile_menu__tab__selected"
                    >
                      {label}
                    </Tab>
                  ))}
                </TabList>

                {HEADER_MENU_ITEMS.map(({ label, data }) => (
                  <TabPanel
                    key={`mobile-menu-tabs-panels-${label}`}
                    className="mobile_menu__tab__panel"
                    selectedClassName="mobile_menu__tab__panel__selected"
                  >
                    <MobileMenuTabPanelContent label={label} data={data} />
                  </TabPanel>
                ))}
              </Tabs>

              <div className="mobile_menu__tab__panel__selected">
                <ul className="mobile_menu__tab__panel__content">
                  {!isLogged && (
                    <>
                      <li className="mobile_menu__tab__panel__item">
                        <button
                          type="button"
                          className="mobile_menu__tab__panel__collapse__btn"
                          onClick={handleRedirectToLogin}
                        >
                          Ingresar
                        </button>
                      </li>

                      <li className="mobile_menu__tab__panel__item">
                        <button
                          type="button"
                          className="mobile_menu__tab__panel__collapse__btn"
                          onClick={handleRedirectToRegister}
                        >
                          Crear cuenta
                        </button>
                      </li>
                    </>
                  )}

                  {isLogged && (
                    <li className="mobile_menu__tab__panel__item">
                      <button
                        type="button"
                        className={classNames(
                          "mobile_menu__tab__panel__collapse__btn",
                          "mobile_menu__tab__panel__collapse__btn__with_icon",
                        )}
                        onClick={handleLogout}
                      >
                        <img
                          src={toBucketAssets('icons/logout-black.svg')}
                          alt="Logout Icon"
                          className="mobile_menu__tab__panel__collapse__btn__icon__img"
                        />

                        Salir
                      </button>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </nav>
        )}
      </MobileMenuProvider>
    </div>
  );
};

export default MobileMenu;
